/**
 * readableTextColor(hex) — devolve "#0A0A0A" (preto) ou "#FFFFFF" (branco)
 * dependendo da luminância da cor de fundo (HEX). Garante contraste WCAG-ish
 * sem precisar de configuração extra.
 *
 * Usa luminância relativa simplificada (sRGB → linear → ponderada por canal).
 * Threshold 0.6 dá um bom equilíbrio entre amarelo/azul-claro (texto preto) e
 * vermelho/azul-escuro (texto branco).
 */
export function readableTextColor(hex, opts = {}) {
  const dark = opts.dark || "#0A0A0A";
  const light = opts.light || "#FFFFFF";
  if (!hex || typeof hex !== "string") return dark;
  let m = hex.replace("#", "").trim();
  if (m.length === 3) m = m.split("").map(c => c + c).join("");
  if (m.length !== 6) return dark;
  const r = parseInt(m.slice(0, 2), 16) / 255;
  const g = parseInt(m.slice(2, 4), 16) / 255;
  const b = parseInt(m.slice(4, 6), 16) / 255;
  // Luminância relativa (sRGB → linear, ponderação ITU-R BT.709)
  const lin = (c) => (c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4));
  const lum = 0.2126 * lin(r) + 0.7152 * lin(g) + 0.0722 * lin(b);
  return lum > 0.6 ? dark : light;
}
